import { Button } from '@trackman/web-shared-components';
import React from 'react';
import { DialogFooterWrapper, RightSide } from './DialogFooterStyles';

interface IProps {
  showBack: boolean;
  primaryLabel: string;
  primaryDisabled: boolean;
  onPrimary: () => void;
  onBack: () => void;
  onCancel: () => void;
}

const DialogFooter: React.FC<IProps> = (props) => {
  const { showBack, primaryLabel, primaryDisabled, onPrimary, onBack, onCancel } = props;

  return (
    <DialogFooterWrapper>
      {showBack ? <Button intent='tertiary' label='Back' onClick={onBack} width='105px' /> : <div />}
      <RightSide>
        <Button intent='tertiary' label='Cancel' onClick={onCancel} width='105px' />
        <Button intent='primary' label={primaryLabel} onClick={onPrimary} width='161px' disabled={primaryDisabled} data-test='next-step' />
      </RightSide>
    </DialogFooterWrapper>
  );
};

export default DialogFooter;
